import Hex from 'crypto-js/enc-hex';
import SHA256 from 'crypto-js/sha256';

// SHA-256 hex of a PIN, matching the server-side `hashPin` in
// `@modules/prism/lib/manifest`. Used to compare an entered PIN against the
// `pinHash` shipped with the manifest-overview / manifest-form blocks
// without putting the raw PIN on the wire or in sessionStorage.
//
// Sync (crypto-js) so the existing sync `onPinEnter(pin: string) => boolean`
// contract on `ManifestPinDialog` stays unchanged. WebCrypto would have
// forced the handler async and rippled through web-compositions.
export const hashPin = (pin: string): string => SHA256(pin).toString(Hex);
